import { createBrowserRouter } from 'react-router-dom'

import { AppShell } from '@/components/layout/AppShell'

import { HomePageV2 } from '@/pages/HomePage'
import { OverviewView } from './pages/HomePage/OverviewView';
import { CheckpointsView } from './pages/HomePage/CheckpointsView';
import { TransactionBlocksView } from './pages/HomePage/TransactionBlocksView';
import { VoteView } from './pages/HomePage/VoteView';

import { CheckpointDetailsPage } from './pages/DetailsPages/CheckpointDetailsPage'
import { TransactionBlockDetailsPage } from './pages/DetailsPages/TransactionBlockDetailsPage';
import { AccountsDetailsPage } from './pages/DetailsPages/AddressDetailsPage'
import { CoinDetailsPage } from './pages/DetailsPages/CoinDetailsPage'
import { PackageDetailsPage } from './pages/DetailsPages/PackageDetailsPage'
import { ObjectDetailsPage } from './pages/DetailsPages/ObjectDetailsPage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      {
        path: '',
        element: <HomePageV2 />,
        children: [
          { index: true, element: <OverviewView /> },
          { path: 'checkpoints', element: <CheckpointsView /> },
          { path: 'transaction-blocks', element: <TransactionBlocksView /> },
          { path: 'vote', element: <VoteView /> }
        ]
      },

      { path: '/checkpoints/:id', element: <CheckpointDetailsPage /> },
      { path: '/transaction-blocks/:digest', element: <TransactionBlockDetailsPage /> },
      { path: '/accounts/:id', element: <AccountsDetailsPage /> },
      { path: '/coins/:id', element: <CoinDetailsPage /> },
      { path: '/packages/:id', element: <PackageDetailsPage /> },
      { path: '/objects/:id', element: <ObjectDetailsPage /> },
    ],
  },
]);
